import React from 'react';


const RoundedPeriod: React.FC = () => {
  return (
    <span className="text-ii-red" style={{ fontFamily: "'Times New Roman', Times, serif", fontWeight: 'bold' }}>
      .
    </span>
  );
};

export default RoundedPeriod;